import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Subscription} from 'rxjs';
import {FormBuilder, FormControl} from '@angular/forms';
import {NotificationService} from '../../../../services/notification.service';
import {debounceTime, finalize, map, startWith, switchMap} from 'rxjs/operators';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import {ClientApiService} from '../../../../services/api/client-api.service';
import {Client} from '../../../../interfaces/entities/client';
import {SelectClientTypeDialogComponent} from '../../../dialogs/select-client-type-dialog/select-client-type-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import {QuickCreateEntityDialogComponent} from '../../../dialogs/quick-create-entity-dialog/quick-create-entity-dialog.component';
import {ClientTypeEnum} from '@app/enums/clients/ClientTypeEnum';

@Component({
    selector: 'app-autocomplete-client',
    templateUrl: './autocomplete-client.component.html',
    styleUrls: ['./autocomplete-client.component.scss'],
    standalone: false
})
export class AutocompleteClientComponent implements OnInit, OnDestroy {

  @Input() clearOnSelect = true;
  @Input() addText = '';
  @Input() addDialogText = '';
  @Input() withLabelMargin = false;

  @Input() preselectedClientType = null;
  @Input() clientType: ClientTypeEnum = null;
  @Input() entityGroupTypeIds: string[] = null;

  @Output() selectClient = new EventEmitter<Client>();

  public isLoadingData = false;

  public clients: Client[] = [];

  public control = new FormControl('');

  private subscription: Subscription;

  constructor(private clientService: ClientApiService,
              private formBuilder: FormBuilder,
              private matDialog: MatDialog,
              private notificationService: NotificationService) {
  }

  ngOnInit(): void {
    this.subscription = this.control.valueChanges.pipe(
      startWith(''),
      debounceTime(250),
      switchMap((input) => {
        this.isLoadingData = true;
        const filter: any = {q: input, clientType: this.clientType};
        if (this.entityGroupTypeIds && this.entityGroupTypeIds.length > 0) {
          filter.entityGroupTypeIds = this.entityGroupTypeIds;
        }
        return this.clientService.getPaginatedClients({page: 1, perPage: 10, filter})
          .pipe(map(data => data.data), finalize(() => this.isLoadingData = false));
      })
    ).subscribe((data) => {
      this.clients = data;
    });
  }

  ngOnDestroy(): void {
  }

  onSelected($event: MatAutocompleteSelectedEvent) {
    this.selectClient.emit($event.option.value);

    if (this.clearOnSelect) {
      this.control.setValue(null);
    }
  }

  quickAddClient() {
    if (this.preselectedClientType) {
      this.openCreateClientDialog(this.preselectedClientType);
    } else {
      const dialogRef = SelectClientTypeDialogComponent.open(this.matDialog, this.addDialogText);

      dialogRef.afterClosed().subscribe((result) => {
        if (result !== false) {
          this.openCreateClientDialog(result);
        }
      });
    }
  }

  private openCreateClientDialog(clientType) {

    const quickEentityAddDialogRef = QuickCreateEntityDialogComponent.open(this.matDialog, {
      entityType: 'client',
      clientType
    });

    quickEentityAddDialogRef.afterClosed().subscribe((createdClient) => {
      this.selectClient.emit(createdClient);

      if (this.clearOnSelect) {
        this.control.setValue(null);
      }
    });
  }
}
